<script setup lang="ts">
import PromosListItem from "./PromosListItem.vue";
import { ProductExtended, PromosOutputParams } from "@/../types/promos-types";
import { usePromosStore, getPromoById } from "@/stores/promosStore";
import { Ref } from "vue";
import { useI18n } from "vue-i18n";

interface Props {
  products: ProductExtended[];
  promosParams: PromosOutputParams;
  upliftInited: Ref<boolean>;
}
defineProps<Props>();

const { locale } = useI18n();

usePromosStore();
</script>

<template>
  <section class="vacv-results">
    <ul class="spa-list plp-list">
      <li
        v-for="(promotion, index) in products"
        :key="promotion._id"
        class="spa-list-item"
      >
        <PromosListItem
          :position="index"
          :promotion="promotion"
          :promosParams="promosParams"
          :localised-promo="
            getPromoById(
              promotion.acv_hotel_id,
              locale,
              promotion.departure_date,
              promotion.return_date
            )
          "
          :uplift-inited="upliftInited"
        />
      </li>
    </ul>
  </section>
</template>

<style lang="scss">
@use "@/assets/scss/product-listing/promos-list.scss" as *;
</style>
